import { render } from "./RaffleCardSkeleton.vue?vue&type=template&id=5a4800f2&scoped=true"
import script from "./RaffleCardSkeleton.vue?vue&type=script&lang=js"
export * from "./RaffleCardSkeleton.vue?vue&type=script&lang=js"

import "./RaffleCardSkeleton.vue?vue&type=style&index=0&id=5a4800f2&scoped=true&lang=css"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4800f2"]])

export default __exports__